import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAccountApi } from '../../hooks/use-settings-api';
import { QK_TWO_FACTOR_RECOVERY_CODES } from './use-recovery-codes';
import { QK_TWO_FACTOR_QR_CODE } from './use-two-factor-qr-code';

/** Shared by first-time enrolment and by `useResetTwoFactor`. */
export function clearTwoFactorSecretQueries(queryClient: ReturnType<typeof useQueryClient>): void {
  // Enabling issues a new secret and new recovery codes, so anything already cached describes
  // the old ones. Remove rather than invalidate: invalidating keeps serving the stale QR/codes
  // as current while the refetch is in flight, and a user who scans or copies in that window
  // walks away with credentials the server has already discarded.
  queryClient.removeQueries({ queryKey: QK_TWO_FACTOR_QR_CODE });
  queryClient.removeQueries({ queryKey: QK_TWO_FACTOR_RECOVERY_CODES });
}

export function useEnableTwoFactor() {
  const { accountApi } = useAccountApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => accountApi.enableTwoFactor(),
    onSuccess: () => clearTwoFactorSecretQueries(queryClient),
  });
}
